export const FLAG_AUSTRALIA = require('./icons/flags/australia.png').default;
export const FLAG_CANADA = require('./icons/flags/canada.png').default;
export const FLAG_UK = require('./icons/flags/united-kingdom.png').default;
export const FLAG_US = require('./icons/flags/united-states.png').default;
